import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=197e8f5c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=197e8f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e8f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197e8f5c')) {
      api.createRecord('197e8f5c', component.options)
    } else {
      api.reload('197e8f5c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=197e8f5c&scoped=true&", function () {
      api.rerender('197e8f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kspV1OJJZAO0/JS/comp/PopupBox.vue"
export default component.exports